export const ValidationRules = {
  age: /^[0-9]+$/,
  postcode: /^[0-9]{4}$/,
  zipcode: /^[0-9]{5}(?:-[0-9]{4})?$/,
  email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  nameField: /^[a-zA-Z][a-zA-Z\s'`‘’&-]*$/,
  phoneFormat: /^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-47-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/,
  usPhoneFormat: /^(?:\+?1[-.●]?)?\(?([0-9]{3})\)?[-.●]?([0-9]{3})[-.●]?([0-9]{4})$/,
  url: /^(?:https?:\/\/)?(?:[a-zA-Z0-9](?:[-a-zA-Z0-9]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,6}(?:\/[-a-zA-Z0-9()@:%_+.~#?&//=]*)?$/,
  strictPostcode: (state) => {
    return {
      NSW: /^[1,2]\d{3}$/,
      ACT: /^2\d{3}$/,
      VIC: /^3\d{3}$/,
      QLD: /^4\d{3}$/,
      SA: /^5\d{3}$/,
      WA: /^6\d{3}$/,
      TAS: /^7\d{3}$/,
      NT: /^0\d{3}$/,
    }?.[state];
  },
};
